define(
	'C3.ShoppingExtensions.LoginRegister.ForgotPassword.Model',
	[
		'SCModel',
		'Utils'
	],
	function(SCModelComponent, Utils){
		'use strict';

		var SCModel = SCModelComponent.SCModel;

		function LoginRegisterForgotPasswordModel() {
			SCModel.call(this);

			// Define properties of the model.
			this.urlRoot = function() {
				return Utils.getAbsoluteUrl(
					getExtensionAssetsPath("services/LoginRegister.ForgotPassword.Service.ss")
				)
			}

			this.validation = function() {
				return {
					 email: {
		                required: true,
		                pattern: 'email',
		                msg: Utils.translate('Please enter a valid email address.')
		            }
				}
			}
		}

		LoginRegisterForgotPasswordModel.prototype = Object.create(SCModel.prototype);

		LoginRegisterForgotPasswordModel.prototype.constructor = LoginRegisterForgotPasswordModel;

		// Return the AMD constructor.
		return LoginRegisterForgotPasswordModel;
	}
);
